module.exports = __webpack_public_path__ + "static/img/solve2.57d05f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solve2.png
// module id = Bn1x
// module chunks = 0